import { render, staticRenderFns } from "./WeeklyLoadChart.vue?vue&type=template&id=39bf2ab6"
import script from "./WeeklyLoadChart.vue?vue&type=script&lang=js"
export * from "./WeeklyLoadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports